import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import { Section, SectionHeader, Image, Paragraph } from 'components';
import './JoinUs.scss';

const JoinUs = () => (
  <StaticQuery
    query={graphql`
      query {
        leftImage: file(relativePath: { eq: "career/rocket.png" }) {
          childImageSharp {
            fluid(maxWidth: 209) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => (
      <Section
        color={'white'}
        additionalClass={'career__join-us-section section--centered'}
      >
        <SectionHeader size={'small'} lineColor={'yellow'} headingType={2}>
          Here, you’re not “just” a developer or a designer!
        </SectionHeader>
        <Paragraph
          additionalClass={'text--light career__join-us-description-paragraph'}
          color={'black'}
          size={'medium'}
        >
          {
            "You change the way people use technology. So, let's step into the world where digital products not only work but also matter, where you pave the way to your own achievements and where excellent team vibes can’t be faked."
          }
        </Paragraph>
        <Paragraph
          additionalClass={'text--light career__join-us-description-paragraph'}
          color={'black'}
          size={'medium'}
        >
          Feels like home? We bet it does.{' '}
          <span className="text--bold">Take a step forward and join us!</span>
        </Paragraph>
        <div className={'career__image-container image--left'}>
          <Image
            src={data.leftImage.childImageSharp.fluid}
            style={{
              objectPosition: 'top center',
            }}
          />
        </div>
      </Section>
    )}
  />
);

export default JoinUs;
